





















































































  import { Component, mixins, ProvideReactive } from 'nuxt-property-decorator'
  import LazyHydrate from 'vue-lazy-hydration'
  import { namespace } from 'vuex-class'
  import { Products, CMS } from '@one/types'
  import { Cart, Wishlist } from '@one/types/dist/orderpath/app'
  import useProductSlugify from '~/composables/useProductSlugify'
  import { TranslateResult } from 'vue-i18n'
  import { AsyncComponent } from 'vue'

  import { MetaInfo, ScriptPropertyJson, MetaPropertyProperty } from 'vue-meta'
  import AddToCartMixin from '~/mixins/AddToCartMixin'
  import SeoMethodsMixin, { DIVIDER } from '~/mixins/SeoMethodsMixin'
  import { Tab } from '~/components/organisms/product/OneProductDataContainer.vue'
  import { StickyStack } from '~/plugins/stickystack'
  import { GTMListType, ProductItem } from '~/plugins/gtm/gtm'
  import { MappedProductStocks } from '~/store/stocks/types'

  const products = namespace('products')
  const cart = namespace('cart')
  const cms = namespace('cms')
  const stocks = namespace('stocks')
  const layout = namespace('layout')
  const wishlist = namespace('wishlist')
  const categories = namespace('categories')

  interface ScriptPropertyJsonExtend extends ScriptPropertyJson {
    type: string
  }

  interface MetaInfoExtend extends Omit<MetaInfo, 'script'> {
    script: ScriptPropertyJsonExtend[]
  }

  interface LocalBasicWishlistOrCart {
    id: string
    name: string
  }

  interface PhotosForMetaInterface {
    [key: string]: MetaPropertyProperty
  }

  enum PRODUCT_DESCRIPTIONS {
    FULL_DESCRIPTION = 'FULL_DESCRIPTION',
    USAGE = 'USAGE',
    BRAND_DESCRIPTION = 'BRAND_DESCRIPTION',
  }

  @Component({
    middleware: ['isAuthenticatedOrPlatformOpened'],
    components: {
      OneCmsGridRender: () => import('~/components/molecules/renders/OneCmsGridRender.vue'),
      OneProductListView: () => import('~/components/organisms/list/OneProductListView.vue'),
      OneRelatedProducts: () => import('~/components/organisms/catalog/OneRelatedProducts.vue'),
      OneProductDescription: () => import('~/components/molecules/rows/OneProductDescription.vue'),
      OneProductDownload: () => import('~/components/organisms/product/OneProductDownload.vue'),
      OneProductTechnicalData: () =>
        import('~/components/organisms/product/OneProductTechnicalData.vue'),
      LazyHydrate,
    },
  })
  export default class Index extends mixins<AddToCartMixin, SeoMethodsMixin>(
    AddToCartMixin,
    SeoMethodsMixin,
  ) {
    @products.Action fetchRelatedProducts: any
    @products.Action fetchProductBySlug: any
    @products.Action fetchProduct: any
    @products.Action filterChanged: any
    @products.Getter getAttributesValue: any
    @products.Getter getProductOrderUnit: any
    @products.Getter getProductCertificates: any
    @products.Getter getProductDataSheets: any
    @products.Getter getRelatedProducts: any
    @products.Getter getProductPrice: any
    @products.Getter productPrice: any
    @products.Getter getProduct: any
    @products.Getter getProductBySlug: any
    @products.Getter getCurrentFiltersQuery: any
    @products.Mutation('CLEAR_PRODUCT_PAGE') clearProductPage: any
    @cart.Getter getCurrentCartId: any
    @cart.Getter getBasicCarts: any
    @cart.Getter getBasicCartById: any
    @cart.Getter getCurrentCart: any
    @stocks.Getter getProductStocks: any
    @stocks.Getter getDefaultWarehouseId: any
    @layout.Getter getCurrency: any
    @layout.Getter isGrossSelected: any
    @layout.Mutation('SET_BREADCRUMBS') setBreadcrumbs: any
    @layout.Mutation('TOGGLE_BREADCRUMBS') toggleBreadcrumbs: any
    @wishlist.Action addProductToWishlist: any
    @wishlist.Getter getCurrentWishlistId: any
    @wishlist.Getter getBasicWishlists: any
    @wishlist.Getter getBasicWishlistById: any
    @wishlist.Getter getCurrentWishlist: any
    @wishlist.Getter getWishlistProduct: any

    @categories.Action selectCategory: any
    @categories.Getter getCategory: any
    @cms.State((state) => state.configuration.registrationEnabled) isRegistrationEnabled: any
    @cms.State((state) => state.grids) grids: any
    @cms.State configuration: any
    @cms.Action fetchGrid: any

    isActive: number = 0
    PRODUCT_DESCRIPTIONS = PRODUCT_DESCRIPTIONS
    mainComponentClass: string = 'one-product-page'

    availableComponents: Record<string, AsyncComponent> = {
      html: () => import('~/components/organisms/grid/shared/OneCmsDynamicComponent.vue'),
      staticHtml: () => import('~/components/organisms/grid/shared/OneCmsStaticComponent.vue'),
      pluginSlot: () => import('~/components/organisms/grid/shared/OnePluginSlotComponent.vue'),
      image: () => import('~/components/molecules/images/OneCmsGridImageComponent.vue'),
      link: () => import('~/components/molecules/links/OneCmsGridLinkComponent.vue'),
      productGallery: () => import('~/components/organisms/grid/product/OneGallery.vue'),
      productDescription: () =>
        import('~/components/organisms/grid/product/OneProductDescriptionSection.vue'),
      productTechnicalInformation: () =>
        import('~/components/organisms/grid/product/OneProductTechnicalDataSection.vue'),
      productStocks: () => import('~/components/organisms/grid/product/OneProductStocks.vue'),
      productActions: () => import('~/components/organisms/grid/product/OneProductActions.vue'),
      productFiles: () => import('~/components/organisms/grid/product/OneProductFilesSection.vue'),
      productRelations: () => import('~/components/organisms/grid/product/OneProductRelations.vue'),
      relatedProducts: () =>
        import('~/components/organisms/grid/product/OneRelatedProductsGridWrapper.vue'),
      recommendedProducts: () =>
        import('~/components/organisms/grid/product/OneRecommendedProductsGridWrapper.vue'),
      youtube: () => import('~/components/organisms/grid/shared/OneCmsYoutubeComponent.vue'),
      textEditor: () => import('~/components/organisms/grid/shared/OneCmsTextEditorComponent.vue'),
      productTitleWithLabels: () =>
        import('~/components/organisms/grid/product/OneProductTitleWithLabels.vue'),
      euEnergyLabel: () => import('~/components/organisms/grid/product/OneEuEnergyLabel.vue'),
      shopForm: () => import('~/components/organisms/grid/static/OneShopForm.vue'),
    }

    head() {
      if (!this.$tenantConfig.tenantKey) {
        return {}
      }
      const image = this.photosForMeta?.map((item) => item.image) ?? []
      const imageUrl = this.photosForMeta?.map((item) => item.imageUrl) ?? []
      const title = this.photosForMeta?.map((item) => item.title) ?? []
      const alt = this.photosForMeta?.map((item) => item.alt) ?? []
      const type = this.photosForMeta?.map((item) => item.type) ?? []
      const url = process.client ? window.location.href : ''
      const productSeo: MetaInfoExtend = {
        title: this.structuredSeoTitle(DIVIDER.DOT, this.productSeoTitle),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.structuredSeoTitle(DIVIDER.DASH, this.productSeoDescription),
          },
          { hid: 'robots', name: 'robots', content: this.robotsSeo(this.product?.seo) },
          { property: 'og:url', content: url },
          { property: 'og:type', content: 'website' },
          { property: 'og:description', content: this.product?.shortDescription },
          {
            property: 'og:locale',
            content: `${this.configuration.lang}_${this.configuration.lang.toUpperCase()}` ?? '',
          },
          { property: 'og:site_name', content: this.configuration.seo.title ?? '' },
          ...image,
          ...imageUrl,
          ...title,
          ...alt,
          ...type,
        ],
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'Product',
              additionalProperty:
                this.product?.attributes?.map((item) => {
                  return {
                    '@type': 'PropertyValue',
                    unitText: item.name,
                    value: item.value,
                  }
                }) ?? null,
              offers: {
                '@type': 'Offer',
                availability: `https://schema.org/${
                  this.stocks?.available ? 'InStock' : 'OutOfStock'
                }`,
                inventoryLevel: this.stocks?.overallQuantity ?? null,
                price: this.price?.price ?? null,
                priceCurrency: this.getCurrency?.code ?? null,
              },
              brand: {
                '@type': 'Brand',
                name: this.product?.brand?.name ?? null,
                description: this.product?.brand?.description ?? null,
              },
              category:
                this.product?.categories.map((item) => {
                  return {
                    '@type': 'CategoryCode',
                    name: item.name,
                  }
                }) ?? null,
              depth: {
                '@type': 'QuantitativeValue',
                minValue: this.product?.netDimension.netDepth ?? null,
              },
              description: this.product?.fullDescription ?? null,
              gtin: this.product?.catalogIndex ?? null,
              hasCertification: this.getProductCertificates(this.product?.id)?.map((item) => {
                return {
                  '@type': 'Certification',
                  name: item.fileName,
                  url: item.url,
                }
              }),
              hasEnergyConsumptionDetails: {
                '@type': 'EnergyConsumptionDetails',
                url: this.product?.energyClass?.energyCard ?? null,
              },
              hasMeasurement: {
                '@type': 'QuantitativeValue',
                minValue: this.product?.measurementUnits.quantityMin ?? null,
                unitCode: this.product?.measurementUnits.orderUnitCode ?? null,
              },
              height: {
                '@type': 'QuantitativeValue',
                minValue: this.product?.netDimension.netLength ?? null,
              },
              image: {
                '@type': 'ImageObject',
                name: this.product?.photos[0].fileName ?? null,
                url: this.product?.photos[0].url ?? null,
              },
              isAccessoryOrSparePartFor:
                this.accessories?.map((item) => {
                  return {
                    '@type': 'Product',
                    productId: item.id,
                  }
                }) ?? null,
              isRelatedTo:
                this.others?.map((item) => {
                  return {
                    '@type': 'Product',
                    productId: item.id,
                  }
                }) ?? null,
              isSimilarTo:
                this.similar?.map((item) => {
                  return {
                    '@type': 'Product',
                    productId: item.id,
                  }
                }) ?? null,
              manufacturer: {
                '@type': 'Organization',
                logo: this.product?.manufacturer.logoImage ?? null,
                name: this.product?.manufacturer.name ?? null,
              },
              name: this.product?.name ?? null,
              productID: this.product?.id ?? null,
              url: this.product?.url ?? null,
              weight: {
                '@type': 'QuantitativeValue',
                minValue: this.product?.netDimension.netWeight ?? null,
              },
              width: {
                '@type': 'QuantitativeValue',
                minValue: this.product?.netDimension.netWidth ?? null,
              },
            },
          },
        ],
      }
      if (this.product?.seo?.title) {
        productSeo.titleTemplate = undefined
      }
      return productSeo
    }

    get photosForMeta(): PhotosForMetaInterface[] | undefined {
      return this.product?.photos?.map((item) => {
        const image = { property: 'og:image', content: item.url ?? '' }
        const imageUrl = { property: 'og:image:url', content: item.url ?? '' }
        const title = { property: 'og:title', content: item.fileName ?? '' }
        const alt = { property: 'og:image:alt', content: item.alt ?? '' }
        const type = { property: 'og:image:type', content: 'image/jpeg' }

        return { image, imageUrl, title, alt, type }
      })
    }

    get content() {
      return this.grids[CMS.Grid.GridSlot.PRODUCT_PAGE] ?? null
    }

    get productDescription(): string | null {
      return this.product?.fullDescription || null
    }

    get stocks(): MappedProductStocks | null {
      return this.getProductStocks(this.product?.id)
    }

    get brandDescription(): string | null {
      return this.product?.brand?.description || null
    }

    get usageDescription(): string | null {
      return this.product?.usage || null
    }

    get hasAnyDescriptions(): boolean {
      return !!this.productDescription || !!this.brandDescription || !!this.usageDescription
    }

    get descriptionTabs(): Array<Tab> {
      const descriptionTabs: Array<Tab> = []
      if (this.product?.fullDescription) {
        descriptionTabs.push({
          name: this.$t('product_page.description') as string,
          slotName: PRODUCT_DESCRIPTIONS.FULL_DESCRIPTION,
        })
      }
      if (this.product?.usage) {
        descriptionTabs.push({
          name: this.$t('product_page.usage') as string,
          slotName: PRODUCT_DESCRIPTIONS.USAGE,
        })
      }
      if (this.product?.brand?.description) {
        descriptionTabs.push({
          name: this.$t('product_page.brand_description') as string,
          slotName: PRODUCT_DESCRIPTIONS.BRAND_DESCRIPTION,
        })
      }
      return descriptionTabs
    }

    get productSeoTitle(): Array<string | null> {
      const { name = null, manufacturer = null } = this.product || {}
      return this.product?.seo?.title
        ? [this.product?.seo.title]
        : [name, manufacturer && manufacturer.name]
    }

    get productSeoDescription(): Array<string | null> {
      return this.product?.seo?.description
        ? [this.product?.seo?.description]
        : [this.product && this.product.name, this.defaultSeoData.description]
    }

    get categoryNameKeywords(): string | null {
      const canonicalCategory = this.product && this.product.canonicalCategory
      return canonicalCategory && this.getCategory(canonicalCategory).name
    }

    get loginToBuyLabel(): string | TranslateResult {
      return this.isRegistrationEnabled
        ? (this.$t('product_page.login_or_register_to_buy') as string)
        : (this.$t('product_page.login_to_buy') as string)
    }

    get attributesValue(): Array<Products.Attribute> {
      if (!this.product) {
        return []
      }
      const attributesValue = this.getAttributesValue(this.product.id)
      return attributesValue.length ? attributesValue : null
    }

    get similar(): Array<Products.ProductIdAndQuantityDto> | null {
      if (!this.product) {
        return null
      }
      const similar = this.getRelatedProducts(this.product.id, 'SIMILAR')
      return similar && similar.length ? similar : null
    }

    get accessories(): Array<Products.ProductIdAndQuantityDto> | null {
      if (!this.product) {
        return null
      }
      const accessories = this.getRelatedProducts(this.product.id, 'ACCESSORY')
      return accessories && accessories.length ? accessories : null
    }

    get others(): Array<Products.ProductIdAndQuantityDto> | null {
      if (!this.product) {
        return null
      }
      const others = this.getRelatedProducts(this.product.id, 'OTHER')
      return others && others.length ? others : null
    }

    get slug(): string {
      return this.$route.params.slug
    }

    @ProvideReactive('currentProduct')
    get product(): Products.Product | null {
      return this.getProductBySlug(this.slug)
    }

    get showDownloadSection() {
      return (
        (this.product &&
          (this.getProductCertificates(this.product.id).length > 0 ||
            this.getProductDataSheets(this.product.id).length > 0)) ||
        false
      )
    }

    onCategoryClick(categoryId: string) {
      this.selectCategory(categoryId)
      const categoryPath: string | null = this.$routes.getCategoryPath()
      if (categoryPath) {
        this.$router.push(categoryPath)
      }
    }

    onManufacturerClick(manufacturer: Products.Manufacturer) {
      this.$router.push(this.$routes.getManufacturerSearchUrl(manufacturer))
    }

    makeActive(id: string | number) {
      this.isActive = Number(id)
    }

    get price(): any | null {
      return this.product && this.getProductPrice(this.product.id, this.isGrossSelected)
    }

    get carts() {
      if (this.$auth.isAuthenticated) {
        return Object.keys(this.getBasicCarts).map((id: string) => this.getBasicCartById(id))
      }
      return (
        (this.getCurrentCart && [
          {
            id: this.getCurrentCartId,
            name: this.getCurrentCart.name,
          },
        ]) ||
        []
      )
    }

    get wishlists(): Array<Wishlist.Responses.BasicWishlist | LocalBasicWishlistOrCart> {
      if (this.$auth.isAuthenticated) {
        return Object.keys(this.getBasicWishlists).map((id: string) =>
          this.getBasicWishlistById(id),
        )
      }
      return (
        (this.getCurrentWishlist && [
          {
            id: this.getCurrentWishlistId,
            name: this.getCurrentWishlist.name,
          },
        ]) ||
        []
      )
    }

    sendImpressions(prds: Array<Products.ProductIdAndQuantityDto> | null, list: string) {
      if (prds !== null) {
        const mappedProducts = prds
          .map((x: Products.ProductIdAndQuantityDto) => this.getProduct(x.id))
          .filter((x) => x)
        if (mappedProducts.length && this.product) {
          const { id, name, brand, canonicalCategory, manufacturer } = this.product
          // FIXME: Types here are invalid - this DTO does not contain names :/
          const price = this.productPrice(this.product.id)
          this.$gtm?.productImpression([
            {
              item_id: id,
              item_list_name: list,
              item_name: name,
              item_brand: (brand && brand.name) || manufacturer.name,
              category: this.$routes.getCategoryPath(canonicalCategory) || '',
              discount: price ? price.catalogPriceNet - price.priceNet : 0,
              price: price ? price.priceNet : 0,
              quantity: price ? price.quantity : 0,
            },
          ])
        }
      }
    }

    setupSmoothScrolling() {
      this.$nextTick(() => {
        document.querySelectorAll('a[data-smooth-scroll]').forEach((element) => {
          element.addEventListener('click', this.onSmoothElementClick)
        })
      })
    }

    onSmoothElementClick(event: any) {
      const hash = event.target.hash.replace(/#/, '')
      if (!hash) {
        return
      }
      const destinationElement = document.getElementById(hash)
      if (!destinationElement) {
        return
      }
      event.preventDefault()
      this.scrollToElement(destinationElement, StickyStack.heightOfStickyElements())
    }

    mounted() {
      this.setupSmoothScrolling()
      this.makeActive(0)
      this.$utils.hideKeyboard()
      this.toggleBreadcrumbs(true)
      this.scrollTop(250)
      if (this.product) {
        const { id, name, brand, canonicalCategory, manufacturer } = this.product
        // FIXME: Similar and accessories are fetched later so no impressions send
        this.$gtm.productDetails({
          item_id: id,
          item_name: name,
          item_brand: (brand && brand.name) || manufacturer.name,
          category: this.$routes.getCategoryPath(canonicalCategory) || '',
          price: this.price ? this.price.price : 0,
          discount: this.price ? this.price.catalogPrice - this.price.price : 0,
          quantity: this.price ? this.price.quantity : 0,
        })
        this.sendImpressions(this.similar, 'related_products')
        this.sendImpressions(this.accessories, 'accessory')
        this.sendImpressions(this.others, 'other')
      }
      this.$plugins.onMounted(this.mainComponentClass, this)
    }

    destroyed() {
      this.clearProductPage()
      this.$plugins.onUnmounted(this.mainComponentClass)
    }

    async validate(context: any) {
      try {
        const product = await context.store.dispatch(
          'products/fetchProductBySlug',
          context.params.slug,
        )
        if (!product) { return false }

        const { params, app, redirect, query } = context
        const currentName = params?.name
        const canonicalPath = app.$routes.getProductPathById(product.id)

        if (!currentName) {
          redirect(301, canonicalPath, query)
          return true
        }

        if (product.url) {
          const currentPath = `/${params.name}-id-${params.slug}`
          if (currentPath !== product.url) {
            redirect(301, product.url, query)
          }
          return true
        }

        const { normalizeSlug } = useProductSlugify()
        const fallbackSlug = normalizeSlug(product.name)

        if (currentName !== fallbackSlug) {
          redirect(301, canonicalPath, query)
        }

        return true
      } catch (e) {
        this.$logger.warn(e)
        return false
      }
    }

    async fetch({ app, store, params }: any) {
      const product =
        store.getters['products/getProductBySlug'](params.slug) ||
        (await store.dispatch('products/fetchProductBySlug', params.slug))
      store.commit('layout/SET_BREADCRUMBS', [
        ...app.$routes.getCategoryBreadcrumbs(product.canonicalCategory),
        { name: product.name },
      ])
      try {
        await store.dispatch('cms/fetchGrid', CMS.Grid.GridSlot.PRODUCT_PAGE)
      } catch (err) {
        app.$logger.warn('Product page grid not available, fallback to default one')
      }
      if (app.$utils.isPurchaseEnabledOrAuthenticated) {
        if (app.$utils.hasPricesEnabled) {
          return Promise.all([
            store.dispatch('products/fetchProductPrice', {
              productId: product.id,
              quantity: 1,
            }),
            store.dispatch('stocks/fetchStockForProduct', {
              productId: product.id,
              warehouses: store.state.stocks.warehouses.allIds,
            }),
          ])
        }
        return store.dispatch('stocks/fetchStockForProduct', {
          productId: product.id,
          warehouses: store.state.stocks.warehouses.allIds,
        })
      }
      return Promise.resolve()
    }

    onLoginClick() {
      this.$router.push('/login')
    }

    onAddToCart({ productId, amountOfProducts }: Cart.Requests.AddProductToCart) {
      this.$wait.start('add-to-cart')
      this.addToCart(productId, amountOfProducts, 'product-page', this.getCurrentCartId).finally(
        () => this.$wait.end('add-to-cart'),
      )
    }

    onAddToWishlist(
      e: Wishlist.Requests.AddNumberOfProductsInWishlistOption & { wishlistId?: string },
    ) {
      this.addProductToWishlist({
        wishlistId: e.wishlistId || this.getCurrentWishlistId,
        newProduct: {
          productId: e.productId,
          amountOfProducts: e.amountOfProducts,
        },
      })
        .then(() => {
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('product_page.alert_added_to_wishlist') as string,
          })
          const addedProduct = this.getWishlistProduct(this.getCurrentWishlistId)(e.productId)
          this.$gtm.addToWishlist(
            {
              item_id: addedProduct.id,
              item_name: addedProduct.name,
              item_brand: addedProduct.brand?.name || '',
              item_list_name: this.getCurrentWishlist.name,
              category: this.$routes.getCategoryPath(addedProduct.canonicalCategory) || '',
              price: addedProduct.prices?.unitNet || 0,
              discount: addedProduct.prices?.catalogPriceNet - addedProduct.prices?.unitNet || 0,
              quantity: e.amountOfProducts || 0,
            },
            addedProduct.price?.unitNet * (e.amountOfProducts || 0),
          )
        })
        .catch((err: any) => {
          this.$logger.warn(err)
          this.$notify({
            group: 'alert',
            type: 'error',
            text: this.$t('errors.add_to_wishlist_error') as string,
          })
        })
    }

    onComplementaryProductClick(product: Products.Product) {
      this.$router.push(this.$routes.getProductPath(product), () => {
        const price = this.getProductPrice(product.id)
        this.$gtm.selectItem(
          {
            item_name: product.name,
            item_id: product.id,
            item_brand: (product.brand && product.brand.name) || product.manufacturer.name,
            category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
            price: price ? price?.price : 0,
            discount: price ? price?.catalogPrice - price?.price : 0,
          } as ProductItem,
          GTMListType.OTHER,
        )
      })
    }

    onAccessoriesProductClick(product: Products.Product) {
      this.$router.push(this.$routes.getProductPath(product), () => {
        const price = this.getProductPrice(product.id)
        this.$gtm.selectItem(
          {
            item_name: product.name,
            item_id: product.id,
            item_brand: (product.brand && product.brand.name) || product.manufacturer.name,
            category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
            price: price ? price?.price : 0,
            discount: price ? price?.catalogPrice - price?.price : 0,
          } as ProductItem,
          GTMListType.ACCESSORY,
        )
      })
    }

    onRelatedProductClick(product: Products.Product) {
      this.$router.push(this.$routes.getProductPath(product), () => {
        const price = this.getProductPrice(product.id)
        this.$gtm.selectItem(
          {
            item_name: product.name,
            item_id: product.id,
            item_brand: (product.brand && product.brand.name) || product.manufacturer.name,
            category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
            price: price ? price?.price : 0,
            discount: price ? price?.catalogPrice - price?.price : 0,
          } as ProductItem,
          GTMListType.RELATED,
        )
      })
    }

    async onRelationClick(slugId: string) {
      const product: Products.Product = await this.fetchProduct(slugId)
      this.$router.push(this.$routes.getProductPath(product))
    }
  }
